<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!--ticket-description.component.html-->
<div class="tiny-ticket-wrapper wrap-relative">
	<error-pin
		class="l-drop-error-top-right push-icon-down"
		[messageHeader]="(errorState | async)?.messageHeader"
		[message]="(errorState | async)?.message"
		*ngIf="showErrorPin"
	></error-pin>
	<mat-form-field
		class="tiny-ticket-description ticket-edit-container__description-container--full-width"
		subscriptSizing="dynamic"
	>
		<mat-label>Description</mat-label>
		<textarea
			automationId="ticketDescription"
			matInput
			cdkTextareaAutosize
			cdkAutosizeMinRows="0.5"
			cdkAutosizeMaxRows="1.5"
			[formControl]="internalField"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
		></textarea>
	</mat-form-field>
</div>
